import { SPACING } from '@alto/design-library-tokens';
import {
  ActionSheetV2,
  Body,
  Description,
  Illustration,
  InlineAlert,
  LgPadding,
  PresentationListItem,
  XsSpacing,
  XxsSpacing,
} from '@alto/design-system';
import { type FertilityCycleMedicationType } from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import React from 'react';
import number1 from '~shared/assets/images/number_1.png';
import number2 from '~shared/assets/images/number_2.png';
import number3 from '~shared/assets/images/number_3.png';
import { CALCULATION_INFO_STRINGS, MEDICATION_TYPES_DISPLAY } from '../constants';

type Props = {
  readonly medicationType: FertilityCycleMedicationType;
};

export const CalculationInfoActionSheet = ({ medicationType }: Props) => {
  return (
    // eslint-disable-next-line @alto/require-analytics-name-for-action-sheet
    <ActionSheetV2 title={`Calculate ${MEDICATION_TYPES_DISPLAY[medicationType]} on hand`}>
      <PresentationListItem
        LeftContent={
          <Illustration
            size="sm"
            source={number1}
          />
        }
        text={<Body>{CALCULATION_INFO_STRINGS[medicationType].STEP_1}</Body>}
      />
      <XsSpacing />
      <PresentationListItem
        LeftContent={
          <Illustration
            size="sm"
            source={number2}
          />
        }
        text={<Body>{CALCULATION_INFO_STRINGS[medicationType].STEP_2}</Body>}
      />
      <XsSpacing />
      <PresentationListItem
        LeftContent={
          <Illustration
            size="sm"
            source={number3}
          />
        }
        text={<Body>{CALCULATION_INFO_STRINGS[medicationType].STEP_3}</Body>}
      />
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <InlineAlert>
          <Description fontFamily="semibold">Example</Description>
          <XxsSpacing />
          <Description>{CALCULATION_INFO_STRINGS[medicationType].EXAMPLE}</Description>
        </InlineAlert>
      </LgPadding>
    </ActionSheetV2>
  );
};
